import { teams } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectTeamSchema = createSelectSchema(teams)

export const insertTeamSchema = createInsertSchema(teams).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export const updateTeamSchema = insertTeamSchema.partial()

export const selectTeamWithLeaderSchema = selectTeamSchema.extend({
  leader: z
    .object({
      id: z.number(),
      user: z
        .object({
          id: z.number(),
          firstName: z.string(),
          lastName: z.string(),
          phoneNumber: z.string().nullable(),
        })
        .optional()
        .nullable(),
    })
    .optional()
    .nullable(),
})

export type Team = z.infer<typeof selectTeamSchema>
export type TeamWithLeader = z.infer<typeof selectTeamWithLeaderSchema>
export type CreateTeam = z.infer<typeof insertTeamSchema>
export type UpdateTeam = z.infer<typeof updateTeamSchema>
